import { call, put, takeEvery } from "redux-saga/effects";
import showToast from "common/Notification";
import { ACCEPT_SHIFT_REQUEST, ADD_OPEN_SHIFT, DELETE_OPEN_SHIFTS, GET_OPEN_SHIFTS, OPEN_SHIFT_REQUEST_LIST, UPDATE_OPEN_SHIFT } from "./actionTypes";
import {
  acceptShiftRequestFail,
  acceptShiftRequestSuccess,
  addOpenShiftFail,
  addOpenShiftSuccess,
  deleteOpenShiftFail,
  deleteOpenShiftSuccess,
  getOpenShiftsFail,
  getOpenShiftsSuccess,
  openShiftRequestListFail,
  openShiftRequestListSuccess,
  updateOpenShiftFail,
  updateOpenShiftSuccess,
} from "./actions";
import {
  onGettingOpenShifts,
  onAddingOpenShifts,
  onUpdatingOpenShifts,
  onGettingShiftRequestList,
  onAcceptingShiftRequest,
  onDeletingOpenShift,
} from "helpers/fakebackend_helper";
import { responseHandler } from "common/CommanFunction";

function* onDelete({ payload: { data, syncList } }) {
  try {
    const response = yield call(onDeletingOpenShift, data);
    if (response.status) {
      yield put(deleteOpenShiftSuccess(response));
      showToast("success", "Deleting Shift", response.message);
      syncList();
    } else {
      yield put(deleteOpenShiftFail(response));
      showToast("warning", "Deleting Shift", response.message);
    }
  } catch (error) {
    yield put(deleteOpenShiftFail(error));
    showToast("error", "Deleting Shift", error);
  }
}

function* onAcceptShiftRequest({ payload: { data, syncList } }) {
  try {
    const response = yield call(onAcceptingShiftRequest, data);
    if (response.status) {
      yield put(acceptShiftRequestSuccess(response));
      showToast("success", "Accepting Request", response.message);
      syncList();
    } else {
      yield put(acceptShiftRequestFail(response));
      showToast("warning", "Accepting Request", response.message);
    }
  } catch (error) {
    yield put(acceptShiftRequestFail(error));
    showToast("error", "Accepting Request", error);
  }
}

function* onAdd({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onAddingOpenShifts, data);
    yield call(responseHandler, "Add Open Shift", response, addOpenShiftSuccess, addOpenShiftFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(addOpenShiftFail(error));
    showToast("error", "Open Shift", error);
  }
}

function* onGetShiftRequestList({ payload: data }) {
  try {
    const response = yield call(onGettingShiftRequestList, data);
    if (response.status) {
      yield put(openShiftRequestListSuccess(response));
    } else {
      yield put(openShiftRequestListFail(response));
      showToast("warning", "Open Shift", response.message);
    }
  } catch (error) {
    yield put(openShiftRequestListFail(error));
    showToast("error", "Open Shift", error);
  }
}

function* onGet({ payload: data }) {
  try {
    const response = yield call(onGettingOpenShifts, data);
    if (response.status) {
      yield put(getOpenShiftsSuccess(response));
    } else {
      yield put(getOpenShiftsFail(response));
      showToast("warning", "Open Shift", response.message);
    }
  } catch (error) {
    yield put(getOpenShiftsFail(error));
    showToast("error", "Open Shift", error);
  }
}

function* onUpdate({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onUpdatingOpenShifts, data);
    yield call(responseHandler, "Update Open Shift", response, updateOpenShiftSuccess, updateOpenShiftFail, onSuccess, onError);
  } catch (error) {
    yield put(updateOpenShiftFail(error));
    showToast("error", "Open Shift", error);
  }
}

export function* OpenShiftSaga() {
  yield takeEvery(GET_OPEN_SHIFTS, onGet);
  yield takeEvery(ADD_OPEN_SHIFT, onAdd);
  yield takeEvery(UPDATE_OPEN_SHIFT, onUpdate);
  yield takeEvery(OPEN_SHIFT_REQUEST_LIST, onGetShiftRequestList);
  yield takeEvery(ACCEPT_SHIFT_REQUEST, onAcceptShiftRequest);
  yield takeEvery(DELETE_OPEN_SHIFTS, onDelete);
}

export default OpenShiftSaga;
